<template>
    <v-container class="text-center" fill-height>
        <v-row justify="center" align="center">
            <v-col cols="12" md="6">
                <p class="text-h5 justify-center blue--text font-weight-medium">
                    {{ $_t('Page Under Maintenance') }} 
                </p>
                <v-card-text>
                    <p>
                    {{ 
                        $_t('Currently, service work is being conducted to improve the quality of our services. We apologize for the inconvenience')
                    }} .
                    </p>
                    <p>
                    {{ $_t("If you'd like to schedule a visit or require immediate assistance, please contact us at") }} <span class="font-weight-bold">{{ contactNumber }}</span>.
                    </p>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn class="white--text green" @click="callNumber">
                    {{ $_t('Call') }} : {{ contactNumber }}
                    </v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
    </v-container>
</template>
  
<script>
import config from '@/config'
export default {
data() {
    return {
    contactNumber: config.contactPhoneNumber
    };
},
methods: {
    callNumber() {
    window.location.href = `tel:${this.contactNumber}`;
    }
}
};
</script>
